<!--  -->
<template>
  <div>
    <div class="chsikew">
      <el-tag v-if="wechatid" style="margin-right:10px">{{ wechatname }}</el-tag>
      <el-button v-if="type!==2" type="primary" style="margin-left:10px" size="mini" @click="choosewecaht">选择小程序</el-button>
    </div>
    <div class="chsikew">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-tag v-if="configureid" style="margin-right:10px">{{ configurename }}</el-tag>
        </el-form-item>
        <el-form-item label="图片查看次数">
          <el-input v-model.number="photoCount" :min="1" type="number" placeholder="填写整数" @input="validateNumberInput" />
        </el-form-item>
      <!-- <el-button type="primary" size="mini" @click="chooseaccount">选择配置</el-button> -->
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" style="margin-left:430px;margin-top:60px" @click="sureclick">确 定</el-button>
    </span>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <chhosewechat ref="chhosewecahtr" @callback="callback" />
    </el-dialog>
    <el-dialog
      title="选择绑定的配置"
      :visible.sync="dialogVisibleaccount"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <chhoseaccount ref="chhoseaccount" @callbackr="callbackr" />
    </el-dialog>
  </div>
</template>

<script>
import { setNumberindexAdd, setNumberindexUpdate } from '@/api/miniProgramPhotoGallery'
import chhosewechat from './chhosewechat.vue'
import chhoseaccount from './chhoseaccount.vue'
// import { nineturntableconfigbind } from '@/api/sourceMaterial.js'
export default {
  components: {
    chhosewechat,
    chhoseaccount
  },
  data() {
    return {
      wechat: null,
      configure: null,
      dialogVisiblewechat: false,
      dialogVisibleaccount: false,
      wechatname: null,
      wechatid: null,
      configurename: null,
      configureid: null,
      photoCount: null,
      app_id: null,
      type: 1
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    validateNumberInput() {
      this.photoCount = String(this.photoCount).replace(/\D/g, '')
    },
    send(type, item, selecttype) {
      this.type = type
      this.wechatid = item.app_id
      this.app_id = item.app_id
      this.wechatname = item.accounts_name
      this.photoCount = item.views_number
    },
    sureclick() {
      if (this.wechatid === null) {
        this.$message.error('请选择小程序')
        return
      }
      // if (this.configureid === null) {
      //   this.$message.error('请选择配置')
      //   return
      // }
      if (this.photoCount === null) {
        this.$message.error('请选择图片次数')
        return
      }
      console.log('this.app_id:', this.app_id)
      if (this.app_id === undefined) {
        setNumberindexAdd({
          views_number: this.photoCount,
          app_id: this.wechatid
        }).then((res) => {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
        })
      } else {
        setNumberindexUpdate({
          views_number: this.photoCount,
          app_id: this.wechatid
        }).then((res) => {
          this.$message({
            message: '编辑成功',
            type: 'success'
          })
        })
      }
      setTimeout(() => {
        this.$emit('close')
      }, 500)
    },
    choosewecaht() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.wechatid = item.app_id
      console.log('item', item)
    },
    chooseaccount() {
      this.dialogVisibleaccount = true
      this.$nextTick(() => {
        this.$refs.chhoseaccount.send()
      })
    },
    callbackr(item) {
      this.dialogVisibleaccount = false
      this.configurename = item.title
      this.configureid = item.id
      console.log('item', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chsikew{
  display: flex;
  align-items: center;
  margin-top: 10px;
}
</style>
